import * as React from 'react';
import { SportEquipment } from '@websky/core/src/Icons';
import icons from './icons';
const BaggageHeaderIcon = ({ rfics }) => {
    return React.createElement(React.Fragment, null, (icons === null || icons === void 0 ? void 0 : icons[rfics]) || SportEquipment);
};
export default BaggageHeaderIcon;
